(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cartBlock = void 0;
var _cart = require("../cart");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var updateCountCart = function updateCountCart(count) {
  var countInfo = document.querySelector('.--count-cart');
  if (!countInfo) return;
  countInfo.textContent = count;
  countInfo.classList.toggle('active', count > 0);
};
var showQtyMsg = function showQtyMsg(input, message) {
  var _input$closest;
  var msg = (_input$closest = input.closest('.cart-block__item-qty-wrapper')) === null || _input$closest === void 0 ? void 0 : _input$closest.querySelector('.--cart-block-qty-msg');
  if (!msg) return;
  msg.textContent = message;
  msg.classList.add('active');
  clearTimeout(msg._hideTimer);
  msg._hideTimer = setTimeout(function () {
    return msg.classList.remove('active');
  }, 3000);
};
var readGtmData = function readGtmData(el) {
  return {
    item_id: el.dataset.gtmSku || '',
    item_name: el.dataset.gtmName || '',
    price: parseFloat(el.dataset.gtmPrice || 0)
  };
};
var initCartBlockActions = function initCartBlockActions(body) {
  var removeButtons = body.querySelectorAll('.--cart-block-remove');
  var _iterator = _createForOfIteratorHelper(removeButtons),
    _step;
  try {
    var _loop = function _loop() {
      var btn = _step.value;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var gtmData = _objectSpread(_objectSpread({}, readGtmData(btn)), {}, {
          quantity: parseInt(btn.dataset.gtmQty || 1, 10)
        });
        removeCartBlockItem(body, btn.dataset.key, gtmData);
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var qtyInputs = body.querySelectorAll('.--cart-block-qty');
  var _iterator2 = _createForOfIteratorHelper(qtyInputs),
    _step2;
  try {
    var _loop2 = function _loop2() {
      var _input$previousElemen, _input$nextElementSib;
      var input = _step2.value;
      var min = function min() {
        return parseInt(input.min) || 1;
      };
      var max = function max() {
        return input.max ? parseInt(input.max) : Infinity;
      };
      var step = function step() {
        return parseInt(input.step) || 1;
      };
      (_input$previousElemen = input.previousElementSibling) === null || _input$previousElemen === void 0 || _input$previousElemen.addEventListener('click', function () {
        var oldQty = parseInt(input.value) || min();
        var newVal = oldQty - step();
        if (newVal < min()) {
          showQtyMsg(input, input.dataset.msgMin);
        } else {
          input.value = newVal;
          updateCartBlockQty(body, input.dataset.key, input.value, _objectSpread(_objectSpread({}, readGtmData(input)), {}, {
            oldQty: oldQty,
            newQty: newVal
          }));
        }
      });
      (_input$nextElementSib = input.nextElementSibling) === null || _input$nextElementSib === void 0 || _input$nextElementSib.addEventListener('click', function () {
        var oldQty = parseInt(input.value) || 1;
        if (oldQty >= max()) {
          showQtyMsg(input, input.dataset.msgMax);
          return;
        }
        var newVal = Math.min(max(), oldQty + step());
        input.value = newVal;
        updateCartBlockQty(body, input.dataset.key, input.value, _objectSpread(_objectSpread({}, readGtmData(input)), {}, {
          oldQty: oldQty,
          newQty: newVal
        }));
      });
      input.addEventListener('change', function () {
        var val = parseInt(input.value);
        var oldQty = parseInt(input.dataset.gtmQty || 1, 10);
        if (!val || val <= 0) {
          removeCartBlockItem(body, input.dataset.key, _objectSpread(_objectSpread({}, readGtmData(input)), {}, {
            quantity: oldQty
          }));
          return;
        }
        var newVal = Math.min(max(), Math.max(min(), val));
        input.value = newVal;
        updateCartBlockQty(body, input.dataset.key, input.value, _objectSpread(_objectSpread({}, readGtmData(input)), {}, {
          oldQty: oldQty,
          newQty: newVal
        }));
      });
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var couponForm = body.querySelector('.--cart-block-coupon-form');
  if (couponForm) {
    couponForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = couponForm.querySelector('[name="coupon_code"]');
      if (input !== null && input !== void 0 && input.value.trim()) {
        applyCoupon(body, input.value.trim(), couponForm);
      }
    });
  }
  var removeCouponBtns = body.querySelectorAll('.--cart-block-remove-coupon');
  var _iterator3 = _createForOfIteratorHelper(removeCouponBtns),
    _step3;
  try {
    var _loop3 = function _loop3() {
      var btn = _step3.value;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        removeCoupon(body, btn.dataset.coupon);
      });
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop3();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var couponToggles = body.querySelectorAll('.--cart-block-coupon-toggle');
  var _iterator4 = _createForOfIteratorHelper(couponToggles),
    _step4;
  try {
    var _loop4 = function _loop4() {
      var toggle = _step4.value;
      toggle.addEventListener('click', function () {
        var _toggle$closest;
        (_toggle$closest = toggle.closest('.cart-block__coupon')) === null || _toggle$closest === void 0 || _toggle$closest.classList.toggle('--open');
      });
    };
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop4();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};
var setLoading = function setLoading(body, state) {
  body.classList.toggle('loading', state);
};
var updateBody = function updateBody(body, html) {
  body.innerHTML = html;
  initCartBlockActions(body);
};
var removeCartBlockItem = function removeCartBlockItem(body, key, gtmData) {
  setLoading(body, true);
  var formData = new FormData();
  formData.append('action', 'apiCartBlockRemove');
  formData.append('key', key);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (r) {
    return r.json();
  }).then(function (data) {
    setLoading(body, false);
    if (data.success) {
      updateCountCart(data.success.cartCount);
      if (data.success.cartBlockHtml) {
        updateBody(body, data.success.cartBlockHtml);
      }
      if (gtmData) (0, _cart.pushCartEvent)('remove_from_cart', gtmData);
    }
  }).catch(function (err) {
    return console.error(err);
  });
};
var updateCartBlockQty = function updateCartBlockQty(body, key, qty, gtmData) {
  setLoading(body, true);
  var formData = new FormData();
  formData.append('action', 'apiCartBlockUpdateQty');
  formData.append('key', key);
  formData.append('qty', qty);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (r) {
    return r.json();
  }).then(function (data) {
    setLoading(body, false);
    if (data.success) {
      updateCountCart(data.success.cartCount);
      if (data.success.cartBlockHtml) {
        updateBody(body, data.success.cartBlockHtml);
      }
      if (gtmData) {
        var delta = gtmData.newQty - gtmData.oldQty;
        if (delta > 0) {
          (0, _cart.pushCartEvent)('add_to_cart', _objectSpread(_objectSpread({}, gtmData), {}, {
            quantity: delta
          }));
        } else if (delta < 0) {
          (0, _cart.pushCartEvent)('remove_from_cart', _objectSpread(_objectSpread({}, gtmData), {}, {
            quantity: Math.abs(delta)
          }));
        }
      }
    }
  }).catch(function (err) {
    return console.error(err);
  });
};
var showCouponMsg = function showCouponMsg(body, message) {
  var isError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var msg = body.querySelector('.--cart-block-coupon-msg');
  if (!msg) return;
  msg.textContent = message;
  msg.classList.toggle('--error', isError);
  msg.classList.add('active');
  setTimeout(function () {
    return msg.classList.remove('active');
  }, 5000);
};
var applyCoupon = function applyCoupon(body, code, form) {
  setLoading(body, true);
  form.classList.add('loading');
  var formData = new FormData();
  formData.append('action', 'apiApplyCoupon');
  formData.append('coupon_code', code);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (r) {
    return r.json();
  }).then(function (data) {
    setLoading(body, false);
    form.classList.remove('loading');
    if (data.success) {
      updateCountCart(data.success.cartCount);
      if (data.success.cartBlockHtml) {
        updateBody(body, data.success.cartBlockHtml);
      }
      return;
    }
    if (data.error) {
      showCouponMsg(body, data.error, true);
    }
  }).catch(function (err) {
    return console.error(err);
  });
};
var removeCoupon = function removeCoupon(body, code) {
  setLoading(body, true);
  var formData = new FormData();
  formData.append('action', 'apiRemoveCoupon');
  formData.append('coupon_code', code);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (r) {
    return r.json();
  }).then(function (data) {
    setLoading(body, false);
    if (data.success) {
      updateCountCart(data.success.cartCount);
      if (data.success.cartBlockHtml) {
        updateBody(body, data.success.cartBlockHtml);
      }
    }
  }).catch(function (err) {
    return console.error(err);
  });
};
var cartBlock = exports.cartBlock = function cartBlock() {
  var body = document.querySelector('.--cart-block-body');
  if (!body) return;
  initCartBlockActions(body);
};

},{"../cart":2}],2:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncCartCount = exports.pushCartEvent = exports.initCartObserver = exports.cartInit = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var countInfo = document.querySelector('.--count-cart');
var removeButtonsSlideCart = [];
var changeQtySlieCart = [];
var alertInfo;
var syncCartCount = exports.syncCartCount = function syncCartCount() {
  var formData = new FormData();
  formData.append('action', 'apiGetCartCount');
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (!data.success) return;
    updateCountBasket(data.success.cartCount);
    if (data.success.html) {
      var slideCart = document.querySelector('.--slide-cart');
      var bgOverflow = document.querySelector('.--slide-cart-overflow');
      var body = slideCart ? slideCart.querySelector('.--slide-cart-body') : null;
      if (body) {
        body.innerHTML = data.success.html;
        updateActionsFromSlideCart(slideCart, body, bgOverflow);
      }
    }
  }).catch(function () {});
};
var cartInit = exports.cartInit = function cartInit() {
  var slideCart = document.querySelector('.--slide-cart');
  var bgOverflow = document.querySelector('.--slide-cart-overflow');
  if (!slideCart || !bgOverflow) {
    return;
  }
  var bodySlideCart = slideCart.querySelector('.--slide-cart-body');
  var togglers = document.querySelectorAll('.--toggler-slide-cart');
  changeQtySlieCart = bodySlideCart.querySelectorAll('.--qty-slide-cart');
  ;
  var _iterator = _createForOfIteratorHelper(togglers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var toggler = _step.value;
      if (bodySlideCart.contains(toggler)) {
        continue;
      }
      toggler.addEventListener('click', function (e) {
        e.preventDefault();
        toggleSlideCart();
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  bgOverflow.addEventListener('click', function (e) {
    e.preventDefault();
    toggleSlideCart();
  });
  var toggleSlideCart = function toggleSlideCart() {
    document.body.classList.toggle('overflow-hidden');
    bgOverflow.classList.toggle('active');
    slideCart.classList.toggle('active');
  };
  addToCart(slideCart, bodySlideCart, bgOverflow);
  updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
  alertInfo = slideCart.querySelector('.--slide-cart-alert');
};
var addToCart = function addToCart(slideCart, bodySlideCart, bgOverflow) {
  var form = document.querySelector('.--add-to-cart-form');
  if (!form) {
    return;
  }
  var button = form.querySelector('.--add-to-cart');
  if (!button) {
    return;
  }
  button.addEventListener('click', function (e) {
    e.preventDefault();
    form.classList.add('loading');
    var formData = new FormData(form);
    formData.append('action', 'apiAddToCart');
    formData.append('nonce', dataTheme.nonce);
    fetch(dataTheme.ajaxUrl, {
      method: 'POST',
      body: formData
    }).then(function (response) {
      return response.json();
    }).then(function (data) {
      form.classList.remove('loading');
      document.body.classList.add('overflow-hidden');
      slideCart.classList.add('active');
      bgOverflow.classList.add('active');
      if (data.success) {
        var _form$querySelector;
        updateCountBasket(data.success.cartCount);
        bodySlideCart.innerHTML = data.success.html;
        updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
        pushCartEvent('add_to_cart', {
          item_id: form.dataset.gtmSku || '',
          item_name: form.dataset.gtmName || '',
          price: parseFloat(form.dataset.gtmPrice || 0),
          quantity: parseInt(((_form$querySelector = form.querySelector('[name=quantity]')) === null || _form$querySelector === void 0 ? void 0 : _form$querySelector.value) || 1, 10)
        });
        return;
      }
      if (data.error) {
        alertCart(alertInfo, data.error);
      }
    }).catch(function (error) {
      console.log(error);
    });
  });
};
var pushCartEvent = exports.pushCartEvent = function pushCartEvent(eventName, item) {
  if (!window.dataLayer || !item.item_name) return;
  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      currency: window.gtm4wp_currency || 'PLN',
      value: +(item.price * item.quantity).toFixed(2),
      items: [{
        item_id: item.item_id || '',
        item_name: item.item_name,
        price: item.price,
        quantity: item.quantity
      }]
    }
  });
};
var updateCountBasket = function updateCountBasket(count) {
  countInfo.textContent = count;
  if (count > 0) {
    countInfo.classList.add('active');
    return;
  }
  countInfo.classList.remove('active');
};
var updateActionsFromSlideCart = function updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow) {
  var togglerInCart = bodySlideCart.querySelector('.--toggler-slide-cart');
  if (togglerInCart) {
    togglerInCart.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.toggle('overflow-hidden');
      bgOverflow.classList.toggle('active');
      slideCart.classList.toggle('active');
    });
  }
  removeButtonsSlideCart = bodySlideCart.querySelectorAll('.--remove-slide-cart');
  if (removeButtonsSlideCart.length) {
    var _iterator2 = _createForOfIteratorHelper(removeButtonsSlideCart),
      _step2;
    try {
      var _loop = function _loop() {
        var element = _step2.value;
        element.addEventListener('click', function (e) {
          e.preventDefault();
          var key = element.dataset.key;
          var gtmData = {
            item_id: element.dataset.gtmSku || '',
            item_name: element.dataset.gtmName || '',
            price: parseFloat(element.dataset.gtmPrice || 0),
            quantity: parseInt(element.dataset.gtmQty || 1, 10)
          };
          removeFromSlideCart(slideCart, bodySlideCart, bgOverflow, key, gtmData);
        });
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  changeQtySlieCart = bodySlideCart.querySelectorAll('.--qty-slide-cart');
  if (changeQtySlieCart.length) {
    var _iterator3 = _createForOfIteratorHelper(changeQtySlieCart),
      _step3;
    try {
      var _loop2 = function _loop2() {
        var element = _step3.value;
        element.addEventListener('change', function (e) {
          e.preventDefault();
          var key = element.dataset.key;
          var qty = element.value;
          if (qty === 'more') {
            var wrapper = element.closest('.slide-cart__item-actions');
            var input = wrapper.querySelector('.--qty-slide-cart-input');
            element.style.display = 'none';
            input.style.display = '';
            input.focus();
            return;
          }
          var gtmData = {
            item_id: element.dataset.gtmSku || '',
            item_name: element.dataset.gtmName || '',
            price: parseFloat(element.dataset.gtmPrice || 0),
            oldQty: parseInt(element.dataset.gtmQty || 1, 10),
            newQty: parseInt(qty, 10)
          };
          updateQtySlideCart(slideCart, bodySlideCart, bgOverflow, key, qty, gtmData);
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop2();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  var qtyInputs = bodySlideCart.querySelectorAll('.--qty-slide-cart-input');
  if (qtyInputs.length) {
    var _iterator4 = _createForOfIteratorHelper(qtyInputs),
      _step4;
    try {
      var _loop3 = function _loop3() {
        var input = _step4.value;
        input.addEventListener('change', function (e) {
          e.preventDefault();
          var key = input.dataset.key;
          var qty = Math.max(parseInt(input.value, 10) || 10, 1);
          input.value = qty;
          var gtmData = {
            item_id: input.dataset.gtmSku || '',
            item_name: input.dataset.gtmName || '',
            price: parseFloat(input.dataset.gtmPrice || 0),
            oldQty: parseInt(input.dataset.gtmQty || 1, 10),
            newQty: qty
          };
          updateQtySlideCart(slideCart, bodySlideCart, bgOverflow, key, qty, gtmData);
        });
      };
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
};
var removeFromSlideCart = function removeFromSlideCart(slideCart, bodySlideCart, bgOverflow, key, gtmData) {
  slideCart.classList.add('loading');
  var formData = new FormData();
  formData.append('action', 'apiRemoveFromSlideCart');
  formData.append('key', key);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    slideCart.classList.remove('loading');
    if (data.success) {
      updateCountBasket(data.success.cartCount);
      bodySlideCart.innerHTML = data.success.html;
      updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
      if (gtmData) pushCartEvent('remove_from_cart', gtmData);
      return;
    }
    if (data.error) {
      alertCart(alertInfo, data.error);
    }
  }).catch(function (error) {
    console.log(error);
  });
};
var updateQtySlideCart = function updateQtySlideCart(slideCart, bodySlideCart, bgOverflow, key, qty, gtmData) {
  slideCart.classList.add('loading');
  var formData = new FormData();
  formData.append('action', 'apiUpdateSlideCartQty');
  formData.append('key', key);
  formData.append('qty', qty);
  formData.append('nonce', dataTheme.nonce);
  fetch(dataTheme.ajaxUrl, {
    method: 'POST',
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    slideCart.classList.remove('loading');
    if (data.success) {
      updateCountBasket(data.success.cartCount);
      bodySlideCart.innerHTML = data.success.html;
      updateActionsFromSlideCart(slideCart, bodySlideCart, bgOverflow);
      if (gtmData) {
        var delta = gtmData.newQty - gtmData.oldQty;
        if (delta > 0) {
          pushCartEvent('add_to_cart', _objectSpread(_objectSpread({}, gtmData), {}, {
            quantity: delta
          }));
        } else if (delta < 0) {
          pushCartEvent('remove_from_cart', _objectSpread(_objectSpread({}, gtmData), {}, {
            quantity: Math.abs(delta)
          }));
        }
      }
      return;
    }
    if (data.error) {
      alertCart(alertInfo, data.error);
    }
  }).catch(function (error) {
    console.log(error);
  });
};
var alertCart = function alertCart(wrapper, alert) {
  wrapper.textContent = alert;
  wrapper.classList.add('active');
  setTimeout(function () {
    wrapper.classList.remove('active');
  }, 6000);
};
var debounce = function debounce(fn) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var timer;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      return fn.apply(void 0, args);
    }, delay);
  };
};
var updateCounter = function updateCounter() {
  var qtys = _toConsumableArray(document.querySelectorAll('.wc-block-components-quantity-selector__input'));
  var total = qtys.reduce(function (sum, el) {
    return sum + (parseInt(el.value || 0, 10) || 0);
  }, 0);
  if (countInfo) {
    updateCountBasket(total);
  }
};
var debouncedUpdateCounter = debounce(updateCounter, 1000);
var initCartObserver = exports.initCartObserver = function initCartObserver() {
  var cartContainer = document.querySelector('.wc-block-cart-items');
  if (!cartContainer) {
    return;
  }
  var observer = new MutationObserver(function () {
    debouncedUpdateCounter();
  });
  observer.observe(cartContainer, {
    childList: true,
    subtree: true,
    attributes: true
  });
};

},{}],3:[function(require,module,exports){
"use strict";

var _cartBlock = require("./app/blocks/cartBlock");
var _cart = require("./app/cart");
(0, _cartBlock.cartBlock)();
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    (0, _cart.initCartObserver)();
  }, 500);
});

},{"./app/blocks/cartBlock":1,"./app/cart":2}]},{},[3]);
